// extracted by mini-css-extract-plugin
export default {"Notice":"MPage_Notice__Bk54h","depth2":"MPage_depth2__+jzCd","noti":"MPage_noti__SoxsH","subtitle":"MPage_subtitle__Fy6Im"};